import type { components } from "@repo/api-types/merchant"
import { request } from "@/utils/service"

export type ShiftOpeningRequest = components["schemas"]["ShiftOpeningRequest"]
export type ShiftOpeningResponse = components["schemas"]["ShiftOpeningResponse"]
export type ShiftOpeningPreview = components["schemas"]["ShiftOpeningPreviewResponse"]
export type ShiftEvent = components["schemas"]["ShiftEventResponse"]
export type ShiftEventPage = components["schemas"]["ShiftEventPageResponse"]
export type ShiftAdjustments = components["schemas"]["ShiftAdjustmentResponse"]

const prefix = "teashop_merchant/merchant_shift_handover_record"

export function previewShiftOpening() {
  return request<IApiResponseData<ShiftOpeningPreview>>({ url: `${prefix}/openings/preview`, method: "GET" })
}

export function submitShiftOpening(data: ShiftOpeningRequest) {
  return request<IApiResponseData<ShiftOpeningResponse>>({
    url: `${prefix}/openings`,
    method: "POST",
    data,
    // Preserve the server envelope so an explicit rejection differs from a lost response.
    skipBusinessCodeCheck: true,
    skipGlobalErrorToast: true,
  })
}

export function getUnassignedShiftEvents(params: { startTime: string; endTime: string; page: number; size: number; eventType?: string }) {
  return request<IApiResponseData<ShiftEventPage>>({ url: `${prefix}/events/unassigned`, method: "GET", params })
}

export function getShiftAdjustments(recordId: number, page: number, size: number) {
  return request<IApiResponseData<ShiftAdjustments>>({ url: `${prefix}/events/adjustments/${recordId}`, method: "GET", params: { page, size } })
}

export function reconcileShiftAdjustments(recordId: number) {
  return request<IApiResponseData<ShiftAdjustments>>({ url: `${prefix}/events/adjustments/${recordId}/reconciliation`, method: "POST" })
}
